import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: '/api', // Adjust this URL to match your backend's URL
  //baseURL: 'http://172.31.242.183:3001', // Adjust this URL to match your backend's URL
  timeout: 5000,
});
export default axiosInstance;